import { createContext } from 'react';

export const StyleContext = createContext<{
	isLightMode: boolean;
	isDarkMode: boolean;
	toggleStyleMode: () => void;
}>({ isLightMode: true, isDarkMode: false, toggleStyleMode: () => null });
